<!-- Button -->
<button
    mat-button
    [matMenuTriggerFor]="userActions"
    class="!p-0 !min-w-0"
>
    <div class="relative">
        <div class="flex items-center justify-center w-10 h-10 rounded-full bg-primary-100 dark:bg-primary-900 text-primary-600 dark:text-primary-400 font-semibold text-sm">
            {{ user?.firstName?.charAt(0) || '' }}{{ user?.lastName?.charAt(0) || '' }}
        </div>
        <agent-status-badge
            *ngIf="myStatus"
            [status]="myStatus"
            size="sm"
            class="absolute bottom-0 right-0"
        ></agent-status-badge>
    </div>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu"
>
    <!-- User info header -->
    <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
        <div class="flex items-center gap-3">
            <div class="relative">
                <div class="flex items-center justify-center w-10 h-10 rounded-full bg-primary-100 dark:bg-primary-900 text-primary-600 dark:text-primary-400 font-semibold text-sm">
                    {{ user?.firstName?.charAt(0) || '' }}{{ user?.lastName?.charAt(0) || '' }}
                </div>
                <agent-status-badge
                    *ngIf="myStatus"
                    [status]="myStatus"
                    size="sm"
                    class="absolute bottom-0 right-0"
                ></agent-status-badge>
            </div>
            <div class="flex flex-col">
                <span class="font-medium text-gray-900 dark:text-white">
                    {{ user?.firstName }} {{ user?.lastName }}
                </span>
                <span class="text-xs text-gray-500 dark:text-gray-400">
                    {{ user?.email }}
                </span>
            </div>
        </div>
    </div>

    <!-- Status selector -->
    <ng-container *ngIf="myStatus" [ngTemplateOutlet]="statusItems"></ng-container>

    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:power'"></mat-icon>
        <span>{{ 'user.signOut' | transloco }}</span>
    </button>
</mat-menu>

<ng-template #statusItems>
    <div class="px-3 pt-2 pb-1 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider" (click)="$event.stopPropagation()">
        {{ 'agentStatus.yourStatus' | transloco }}
    </div>
    <button mat-menu-item (click)="onStatusChange('online')">
        <span class="flex items-center gap-2">
            <agent-status-badge status="online" size="sm"></agent-status-badge>
            {{ 'agentStatus.online' | transloco }}
        </span>
    </button>
    <button mat-menu-item (click)="onStatusChange('on_break')">
        <span class="flex items-center gap-2">
            <agent-status-badge status="on_break" size="sm"></agent-status-badge>
            {{ 'agentStatus.on_break' | transloco }}
        </span>
    </button>
    <button mat-menu-item (click)="onStatusChange('inactive')">
        <span class="flex items-center gap-2">
            <agent-status-badge status="inactive" size="sm"></agent-status-badge>
            {{ 'agentStatus.inactive' | transloco }}
        </span>
    </button>
    <button mat-menu-item (click)="onStatusChange('offline')">
        <span class="flex items-center gap-2">
            <agent-status-badge status="offline" size="sm"></agent-status-badge>
            {{ 'agentStatus.offline' | transloco }}
        </span>
    </button>
    <mat-divider></mat-divider>
</ng-template>
